import React, { useEffect, useState } from 'react';
import { MediaPlayer } from './MediaPlayerThree/MediaPlayerThree';

interface MediaPlayerWrapperProps {
 containerId: string; // Add containerId
  apiKey: string;
  slikeId: string;
  Pl_Type: string;
  autoPlay: boolean;
  skipAd: boolean;
  mute: boolean;
  playInBackground: boolean;
}

declare var window: CustomWindow;
interface CustomWindow extends Window {
  loadingStarted: any;
}

const MediaPlayerWrapper: React.FC<MediaPlayerWrapperProps> = (props) => {
  const [scriptsLoaded, setScriptsLoaded] = useState(false);

  useEffect(() => {
    const loadScripts = async () => {
      window.loadingStarted = true;
      // Load the scripts dynamically
      await Promise.all([
        loadScript('https://imasdk.googleapis.com/js/sdkloader/ima3.js'),
        loadScript('https://tvid.in/sdk/loader.js')
      ]);
      // Set the state to indicate that scripts are loaded
      setScriptsLoaded(true);
      
    };
    if(!window.loadingStarted){
    loadScripts();
    }else{setScriptsLoaded(true)}
  }, []);

  return scriptsLoaded ? <MediaPlayer {...props} /> : null;
};

const loadScript = (src: string) => {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve();
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

export default MediaPlayerWrapper;
